import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import sorento from "../../../../assets/info/sorento-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const KiaSorento = () => {
  useSmallNav("Kia Sorento");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Kia Sorento"} bolder />
        <InfoHero image={sorento} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Kia Sorento? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Jeśli tak, to trafiłeś we właściwe miejsce."}
            />
            <p>
              Czy Twoje zawieszenie samopoziomujące Sorento uległo awarii i
              właśnie otrzymałeś ceny za zamienniki? Jeśli tak, to właśnie
              znalazłeś opłacalne rozwiązanie swojego uszkodzonego zawieszenia
              Sorento.
            </p>
            <p>
              Zestaw ten zastępuje oryginalne zawieszenie samopoziomujące.
              Zestaw ten jest bezpośrednim zamiennikiem i nie są wymagane żadne
              modyfikacje w celu instalacji. Nie są również wymagane żadne
              dodatkowe części.
            </p>
            <p>
              „Czy mój pojazd naprawdę powróci do pierwotnej wysokości jazdy?”
              Tak, zdecydowanie! Istnieje wiele przykładów sytuacji, w których
              Sorento były wymienione samopoziomujące amortyzatory na
              konwencjonalne amortyzatory, które następnie były umieszczone zbyt
              nisko. Dzieje się tak dlatego, że oryginalna sprężyna jest zbyt
              słaba, aby utrzymać cały ciężar samochodu, gdyż zwykle wspomaga ją
              w tym zadaniu amortyzator samopoziomujący.
            </p>
            <p>
              Firma Pedders Suspension przezwycięża ten problem, dostarczając
              dopasowany zestaw amortyzatorów i sprężyn specjalnie do tego celu.
              Możesz być pewny, że pojazd będzie miał odpowiednią wysokość, a
              kłopotliwe i drogie amortyzatory samopoziomujące przejdą do
              historii.
            </p>
            <p>
              Należy pamiętać, że są to 2 wersje tylnego zawieszenia Sorento. Do
              około połowy 2007 roku górne mocowanie amortyzatora miało
              mocowaniem typu „oczko”. Późniejsze modele wykorzystują mocowanie
              „szpilkowe”. Ten zestaw jest przeznaczony do wcześniejszych
              uchwytów typu „oczko”. Jeśli nie jesteś pewien, spójrz na zdjęcie.
            </p>
            <p>
              Należy pamiętać, że nasze pomiary wysokości pojazdów opierają się
              na kołach 16-calowych. Nie oznacza to jednak, że będzie pasować
              tylko do samochodów z kołami 16 cali. Zestaw będzie pasował
              niezależnie od rozmiaru koła.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/9PvSqeTDVxk"
              title={"Kia Sorento Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Kia Sorento Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Kia")
              .models.find((e) => e.display === "Sorento")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Kia" model="Sorento" /> */}
      </Container>
    </section>
  );
};

export default KiaSorento;
